export default "__VITE_ASSET__db9b6313__"